import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    argonList: []
};
const getters = {
    getArgon: state => state.argonList
};
const mutations = {
    SET_ARGON_INFO(state, data){
        state.argonList = data
    }
};
const actions = {
    getArgon({commit}){
        axiosGet(`crm/argons?all`).then(({data}) => {
            commit('SET_ARGON_INFO', data)
        }).catch((error) => console.log(error))
    }
};



export default {
    state,
    getters,
    actions,
    mutations
}
